import React from 'react';
import { Section } from './ui/Section';
export function ContentOverview() {
  const tomos = [{
    icon: '📘',
    title: 'Negocio High-Ticket',
    desc: 'Precios premium, membresías y posicionamiento'
  }, {
    icon: '📗',
    title: 'Marketing y Sala Llena',
    desc: 'Meta Ads, Instagram y WhatsApp para captar alumnas'
  }, {
    icon: '📙',
    title: 'Metodología de Enseñanza',
    desc: 'Pedagogía, niveles y progresión que fideliza'
  }, {
    icon: '📕',
    title: 'Programación Anual',
    desc: '12 meses planificados con fichas listas'
  }, {
    icon: '📓',
    title: 'Operaciones y Salud',
    desc: 'Contratos, finanzas y protocolo de longevidad'
  }, {
    icon: '📔',
    title: 'Escalamiento y Equipo',
    desc: 'Ingresos más allá de tu presencia física'
  }];
  return <Section variant="alt" data-id="element-95">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-4 text-brand-title" data-id="element-96">
        📦 6 TOMOS · 6 BONOS · 480 PÁGINAS
      </h2>

      <div className="text-center text-sm text-brand-textMuted mb-8 md:hidden tracking-wide" data-id="element-97">
        ← Scroll to see full table →
      </div>

      <div className="overflow-x-auto" data-id="element-98">
        <table className="w-full min-w-[600px] border-collapse bg-white rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-99">
          <thead data-id="element-100">
            <tr className="bg-brand-cardPeach border-b border-brand-border" data-id="element-101">
              <th className="text-left p-4 text-brand-title font-heading font-bold tracking-wide uppercase text-sm" data-id="element-102">
                Tomo
              </th>
              <th className="text-left p-4 text-brand-title font-heading font-bold tracking-wide uppercase text-sm" data-id="element-103">
                Lo que resuelve
              </th>
            </tr>
          </thead>
          <tbody data-id="element-104">
            {tomos.map((tomo, i) => <tr key={i} className="hover:bg-brand-card/30 transition-colors border-b border-brand-border/30 last:border-0" data-id="element-105">
                <td className="p-4" data-id="element-106">
                  <div className="flex items-center gap-3" data-id="element-107">
                    <span className="text-2xl" data-id="element-108">{tomo.icon}</span>
                    <span className="font-heading font-bold text-brand-text" data-id="element-109">
                      {tomo.title}
                    </span>
                  </div>
                </td>
                <td className="p-4 text-brand-text font-body" data-id="element-110">{tomo.desc}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Section>;
}